import { NotificationService } from '@/services/notification-service';

export default {
  install: (app) => {
    const {
      config: { globalProperties },
      _context: { provides },
    } = app;
    app.provide('notificationService', new NotificationService(globalProperties, provides));
  },
};
